export default "__VITE_ASSET__39fb9f48__"